export default __webpack_public_path__ + "static/media/chord-generator-tablet.a2ea0cc1.png";